import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Table, Col, Row, Card, Typography, Tag } from "antd";
import { listReferrals } from "../../redux/slice/referralSlice";


const { Title } = Typography;

export default function ReferralsTableList() {
  const dispatch = useDispatch();
  const [tableParams, setTableParams] = useState({
    pagination: { current: 1, pageSize: 10, total: 0 },
  });

  useEffect(() => {
    dispatch(listReferrals({ page: tableParams.pagination.current, limit: tableParams.pagination.pageSize }));
  }, [dispatch, tableParams.pagination.current, tableParams.pagination.pageSize]);

  const { referralList = {}, listingReferData } = useSelector((state) => state.refer);
  console.log("listReferralsData", referralList);

  // Handle response: { data: [], pagination: { page, limit, total, totalPages } }
  const referrals = referralList?.data || [];
  const pagination = referralList?.pagination || {};
  const { total = 0, page = 1, limit = 10 } = pagination;

  useEffect(() => {
    if (total > 0) {
      setTableParams((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, total: total, pageSize: limit, current: page },
      }));
    }
  }, [total, page, limit]);

  const handleTablePageChange = (pagination) => {
    setTableParams({
      pagination: { ...pagination },
    });
  };

  const columns = [
    {
      title: <Title level={5}>Referred User</Title>,
      dataIndex: "referredUserName",
      key: "referredUserName",
      render: (text, record) => (
        <div>
          <p style={{ fontSize: "14px", margin: 0, fontWeight: 500 }}>{text || "N/A"}</p>
          <p style={{ fontSize: "12px", margin: 0, color: "#666" }}>{record.referredUserEmail}</p>
        </div>
      ),
    },
    {
      title: <Title level={5}>Bonus</Title>,
      dataIndex: "bonusAmount",
      key: "bonusAmount",
      render: (amount, record) => (
        <span style={{ fontSize: "14px" }}>{record.currency} {amount}</span>
      ),
    },
    {
      title: <Title level={5}>Status</Title>,
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = status === 'completed' ? 'green' : status === 'pending' ? 'orange' : 'red';
        return <Tag color={color}>{status?.toUpperCase()}</Tag>;
      },
    },
    {
      title: <Title level={5}>Registered At</Title>,
      dataIndex: "referredUserRegisteredAt",
      key: "referredUserRegisteredAt",
      render: (date) => (
        <span style={{ fontSize: "12px" }}>
          {date ? new Date(date).toLocaleDateString() : "N/A"}
        </span>
      ),
    },
  ];

  return (
    <>
      {referrals.length === 0 && !listingReferData ? (
        <div className="card mt-4 p-4">
          <div className="users-wi">
            <img src="./images/users.gif" alt="Users" />
          </div>
          <h3 className="h4 text-center">
            No one has joined using your referral code yet. <br /> Why not
            invite friends now to start earning more.
          </h3>
        </div>
      ) : (
        <div className="site-card-wrapperr2" style={{ marginTop: "2%" }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Card
                bordered={false}
                title={<Title level={4}>My Referrals</Title>}
                className="criclebox tablespace mb-24"
              >
                <div className="table-responsive2">
                  <div className="table-container2">
                    <Table
                      columns={columns}
                      dataSource={referrals}
                      pagination={tableParams.pagination}
                      loading={listingReferData}
                      rowKey={(record) => record._id}
                      onChange={handleTablePageChange}
                      className="ant-border-space"
                    />
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
            
        </div>
      )}
    </>
  );
}
